import * as React from 'react';
import { Page } from '../../cookbook-ui/Page_SC';

export interface Props {}

export const Grid: React.FC<Props> = (props) => {
  return (
    <Page>
      <p className="kxi-text-xlarge kxi-text-600">Grid</p>
      <br />
      <p>No grid description yet.</p>
      <hr />
      <br />
      <br />
      <p>No grid yet, check back later!</p>
    </Page>
  );
};
